import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DEFAULT_IMAGE_140 } from '../../middleware/types'

const CategoryListingContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  const [containerObjectState, setContainerObjectState] = useState(containerObject && containerObject.results ? containerObject.results : "")
 

  
  function replaceImage(event) {
		event.target.src = DEFAULT_IMAGE_140;
	}

  useEffect(()=>{
		const titleElement = document.querySelector('title')
		if(containerObject.currentCategoryName) { 
			titleElement.innerHTML = containerObject.currentCategoryName + " | Carolina Biological Supply"
		} else {
			titleElement.innerHTML = "Carolina Biological Supply"
		}
	},[containerObject])
 
 
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 categoryListingPage ${containerObject?.enableContentVisibilityAttribute === "N" ?  '':'content-visibility-class'}`}>
      {containerObjectState && containerObject.results && containerObject.results.length > 0 ? <>
       
        <div className='mt-4'>
          <div className='col-md-12'>
            <div className='row'>
              {containerObjectState.map((item, index) => {
                return (
                  <>
                    <div className='col-md-3 col-6'>
                      <Link className='c-category-list' to={item["navigationState"] ? item["navigationState"] : ""}>
                        <img onError={replaceImage} className='' alt={item["label"] ? item["label"] : ""} src={item.properties["category.thumbnail_url"]? item.properties["category.thumbnail_url"] : ""} decoding='async' fetchpriority={index < containerObject.documentFetchPriorityHighCount ? "high" : "low"} loading={index < containerObject.documentFetchPriorityHighCount ? "" : "lazy"} />
                        <p className='c-category-title'>{item["label"] ? item["label"] : ""}</p>
                      </Link>
                    </div>

                  </>
                )
              })}
            </div>
          </div>
        </div> </> : ""}

    </div>
  )
}

export default CategoryListingContainer